export default __webpack_public_path__ + "static/e-z-trip-c986feba62b7f9805c400aa97907dc9f.png";